import React from 'react';

import ScheduleStatusChip from 'components/Chips/ScheduleStatusChip';

import { StyledMenuItem, StyledSelect } from '../styles';
import { ScheduleListStatus, ScheduleStatusSelectProps } from './types';

const OPTIONS: ScheduleListStatus[] = ['active', 'paused'];

const ScheduleStatusSelect: React.FunctionComponent<ScheduleStatusSelectProps> = ({ onChange, ...props }) => (
  <StyledSelect {...props} fullWidth onChange={(event) => onChange(event.target.value as ScheduleListStatus)}>
    {OPTIONS.map((status) => (
      <StyledMenuItem key={status} value={status}>
        <ScheduleStatusChip isPaused={status === 'paused'} pauseReason={null} />
      </StyledMenuItem>
    ))}
  </StyledSelect>
);

export default ScheduleStatusSelect;
